import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { CopyIcon } from '../../icons';
import { COPY_BTN_TIMEOUT } from '../../constants';
import styles from './CopyButton.module.scss';

const CopyButton = ({ className = '', value }) => {
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    let timer;

    if (isCopied) {
      timer = setTimeout(() => {
        setIsCopied(false);
      }, COPY_BTN_TIMEOUT);
    }
    return () => clearTimeout(timer);
  }, [isCopied]);

  return (
    <button
      className={cn(styles.copyButton, className)}
      onClick={() => {
        navigator.clipboard.writeText(value).then(() => setIsCopied(true));
      }}
    >
      {isCopied ? 'COPIED!' : 'COPY URL'}
      <CopyIcon className={styles.copyButtonIcon} />
    </button>
  );
};

export default CopyButton;
